// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageInfo from '../../package.json';
import { AppConfigService } from '../app/tabms/services/app-config.service';

let config: any = {};
export const environment = {
  appVersion: packageInfo.version,
  production: false,
  environmentName: 'dev',
  SignalrHubsUrl: 'https://dev-host.tab-erp.com/signalr-hubs/notification',
  baseUrl: 'https://dev-host.tab-erp.com/api/v1/',
  baseUrlHR: 'https://dev-hr-api.tab-erp.com/api/v1/',
  baseUrlSS: 'https://dev-selfservices-api.tab-erp.com/',
  baseUrlInv:'https://dev-inventory-api.tab-erp.com/api/v1/',
  baseUrlRE: 'https://dev-renthost.tab-erp.com/api/v1/',
  baseUrlSec: 'https://dev-tabassist-api.tab-erp.com/api/v1/',
  apiUrl: 'https://dev-host.tab-erp.com/api/',
  apiUrlHR: 'https://dev-hr-api.tab-erp.com/api/',
  apiUrlSS: 'https://dev-selfservices-api.tab-erp.com/api/',
  apiUrlInv:'https://dev-inventory-api.tab-erp.com/api/',
  apiUrlRE: 'https://dev-renthost.tab-erp.com/api/',
  apiUrlSec: 'https://dev-tabassist-api.tab-erp.com/api/',
  reportApi: 'https://dev-host.tab-erp.com/api/Viewer/{action}',
  reportDesignerApi:'https://dev-host.tab-erp.com/api/designer',
  filesUrl: 'https://dev-host.tab-erp.com/',
  issuer: 'https://dev-auth.tab-erp.com',
  tokenEndpoint: 'https://dev-auth.tab-erp.com/connect/token',
  redirectUri: 'https://dev-tabassist.tab-erp.com/auth-callback',
  post_logout_redirect_uri: 'https://dev-tabassist.tab-erp.com',
  clientId: 'TABMS_Front_Prod',
  scope:'Adminstration HR AdminRealEstate Inventory SelfServices Secretary',
  googleMapsApiKey: 'AIzaSyBG9PDPPGpqDQe1g2Dr7lRatEyRl09mw88',
  googleMapsMapId: '562dfe064da4d0851ecbf89d'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
